export default "__VITE_ASSET__vCu3VZuy__"